import { nectarApi } from './client'
import type {
  AvailabilityResponse,
  JoinResponse,
  MySessionsResponse,
  ReadyResponse,
  RestartResponse,
  StatusResponse,
  VoteResponse,
} from './conversation-types'

export const signalAvailability = (projectId: string) =>
  nectarApi.post<AvailabilityResponse>(`/v1/conversations/sessions/projects/${projectId}/available`)

export const fetchMySessions = (projectId: string) =>
  nectarApi.get<MySessionsResponse>('/v1/conversations/sessions/mine', { projectId })

export const joinSession = (sessionId: string) =>
  nectarApi.post<JoinResponse>(`/v1/conversations/sessions/${sessionId}/join`)

export const fetchSessionStatus = (sessionId: string) =>
  nectarApi.get<StatusResponse>(`/v1/conversations/sessions/${sessionId}/status`)

export const signalReady = (sessionId: string) =>
  nectarApi.post<ReadyResponse>(`/v1/conversations/sessions/${sessionId}/ready`)

export const leaveSession = (sessionId: string) =>
  nectarApi.post<{ status: 'left' }>(`/v1/conversations/sessions/${sessionId}/leave`)

export const requestRestart = (sessionId: string) =>
  nectarApi.post<RestartResponse>(`/v1/conversations/sessions/${sessionId}/restart`)

export const voteRestart = (sessionId: string, restartId: string, vote: boolean) =>
  nectarApi.post<VoteResponse>(
    `/v1/conversations/sessions/${sessionId}/restart/${restartId}/vote`,
    { vote }
  )
